import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { StripeReader } from '../../../../../../../../../models/location';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../../utils';
import { AccountService } from '../../../../../../../../../services/account/account.service';
import { LocationService } from '../../../../../../../../../services/location/location.service';


@Component({
  selector: 'app-remove-stripe-reader-modal',
  templateUrl: './remove-stripe-reader-modal.component.html',
  styleUrls: ['./remove-stripe-reader-modal.component.css']
})
export class RemoveStripeReaderModalComponent implements OnInit {

  @Input() reader: StripeReader;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public loadingRemove = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public locationService: LocationService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }
  }

  public handleRemove() {
    this.loadingRemove = true;

    this.errorMessage = '';
    this.errors = {};

    this.locationService
      .removeTerminal(this.reader)
      .then(() => {
        this.savedCallback({
          text: this.reader.label + ' removed successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to remove this payment terminal.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingRemove = false; });
  }

}
